(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/collections/syndicates.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/collections/syndicates.js');
"use strict";


(function (Backbone, svs, Radio) {
  'use strict';

  let api = 3;
  if (svs.core.detect.feature('ft-its-api-version')) {
    api = 4;
  }
  svs.syndicate.core.collections.getSyndicateCollectionInstance = function (models, options) {
    if (!svs.syndicate.core.collections.syndicates) {
      svs.syndicate.core.collections.syndicates = new svs.syndicate.core.collections.Syndicates(models, options);
    }
    return svs.syndicate.core.collections.syndicates;
  };
  svs.syndicate.core.collections.hasSyndicateCollectionInstance = function () {
    return svs.syndicate.core.collections.syndicates;
  };
  svs.syndicate.core.collections.Syndicates = Backbone.Collection.extend({
    logger: svs.core.log.getLogger('component:core.collection.Syndicates'),
    model: svs.syndicate.core.models.Syndicate,
    url: '/social/1/syndicates',
    initialize(models) {
      if (models) {
        this.reset(models, {
          parse: true
        });
      } else if (svs.utils.ns.isNamespace('svs.syndicate.core.data.syndicates')) {
        this.reset(svs.syndicate.core.data.syndicates, {
          parse: true
        });
        this.currentMember = svs.syndicate.core.data.customerId;
        delete svs.syndicate.core.data.syndicates; 
      }

      this.getChannel().on('LeaveSyndicate', this.leaveSyndicate, this);
      this.getChannel().on('TerminateSyndicate', this.terminateSyndicate, this);
      this.getChannel().on('RejectRecommendation', this.rejectRecommendation, this);
    },
    getSyndicates(callback) {
      svs.core.jupiter.get('/social/1/syndicates', data => {
        if (data.customerSyndicates) {
          this.logger.debug("Has fetched ".concat(data.customerSyndicates.length, " syndicates"));
          this.reset(data.customerSyndicates);
          this.currentMember = data.customerId;
          if (callback) {
            callback();
          }
        }
      }, (xhr, textStatus, errThrown) => {
        if (callback) {
          callback(errThrown);
        }
      });
    },
    getSyndicate(syndicateId) {
      return this.find(syndicate => syndicate.get('syndicateId') === syndicateId);
    },
    getSyndicatesWhereNotOwner() {
      return this.filter(
      syndicate => !(syndicate.get('memberRole') & svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER === svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER));
    },
    getSyndicatesWhereOwner() {
      return this.filter(
      syndicate => syndicate.get('memberRole') & svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER === svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER);
    },
    getTotalAmountShares() {
      let total = 0;
      this.each(syndicate => {
        total += parseInt(syndicate.get('memberBalance'), 10);
      });
      return total;
    },
    createLightSyndicate(data) {
      const newSyndicateData = {};
      if (!_.isUndefined(data.playableAmount) && !_.isUndefined(data.syndicateId) && !_.isUndefined(data.syndicateName) && _.isString(data.syndicateName)) {
        newSyndicateData.memberRole = 4;
        newSyndicateData.playableAmount = data.playableAmount;
        newSyndicateData.syndicateId = parseInt(data.syndicateId, 10);
        newSyndicateData.syndicateName = data.syndicateName;
        newSyndicateData.tooFewMembers = false;
        newSyndicateData.currentMember = new Backbone.Model();
        if (_.isString(data.memberState)) {
          newSyndicateData.memberState = data.memberState;
        }
        newSyndicateData.isFull = false;
        return this.add(newSyndicateData);
      }
      this.logger.error('Missing required data to construct a light syndicate model');
    },
    leaveSyndicate(syndicate) {
      const currentMember = this.currentMember || svs.arena.data.customerId;
      const leaveDialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'spela-tillsammans',
        title: 'Bekräfta',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: svs.syndicate.core.templates.confirm_leave_syndicate(syndicate.toJSON())
        }],
        actions: [{
          title: 'Avbryt'
        }, {
          title: 'Lämna laget',
          showLoader: true,
          callback: () => {
            svs.core.jupiter.delete({
              path: "/social/".concat(api, "/syndicates/").concat(syndicate.get('syndicateId'), "/member?memberId=").concat(currentMember)
            }, () => {
              this.onLeaveSyndicateSuccess(syndicate, leaveDialog);
            }, textStatus => {
              this.onLeaveSyndicateError(syndicate, textStatus, leaveDialog);
            });
          }
        }]
      });
      svs.ui.dialog.api.add(leaveDialog);
    },
    onLeaveSyndicateSuccess(syndicate, previousDialog) {
      const self = this;
      const syndicateId = syndicate.get('syndicateId');
      const currentMember = this.currentMember || svs.arena.data.customerId;
      syndicate.trigger('destroy', syndicate);
      self.remove(syndicate);
      self.logger.debug("Has left syndicate: ".concat(syndicate.get('syndicateName')));
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'thumbs-up',
        title: 'Klart',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: svs.syndicate.core.templates.leave_syndicate_confirmation(syndicate.toJSON())
        }],
        actions: [{
          title: 'Ok',
          callback() {
            self.getChannel().trigger('LeftSyndicate', {
              syndicateId,
              userId: currentMember
            });
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
      if (previousDialog) {
        previousDialog.close();
      }
    },
    onLeaveSyndicateError(syndicate, textStatus, previousDialog) {
      this.logger.error("Error when leaving syndicate: ".concat(textStatus));
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: 'Tekniskt fel!',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: svs.syndicate.core.templates.technical_failure_leave_syndicate(syndicate.toJSON())
        }],
        actions: [{
          title: 'Ok'
        }]
      });
      svs.ui.dialog.api.add(dialog);
      if (previousDialog) {
        previousDialog.close();
      }
    },
    requestActivation(syndicate) {
      const self = this;
      const currentMember = this.currentMember || svs.arena.data.customerId;
      const options = {
        path: '/social/1/syndicates/reactivaterequest',
        data: {
          syndicateId: syndicate.get('syndicateId')
        }
      };
      function successFn() {
        self.logger.debug("Successfully requested activation for member: ".concat(currentMember, " in syndicate: ").concat(syndicate.get('syndicateName')));
        const owner = syndicate.getOwner();
        const ownerName = owner ? "".concat(owner.get('firstName'), " ").concat(owner.get('lastName')) : 'lagledaren';
        const message = svs.syndicate.core.templates.request_activation_confirmation({
          owner: ownerName
        });
        svs.ui.loader.hide();
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'checkmark',
          title: message,
          actions: [{
            title: 'Ok'
          }]
        }));
      }
      function errorFn(textStatus) {
        self.logger.error("Error when requesting reactivation: ".concat(textStatus));
        svs.ui.loader.hide();
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.ERROR,
          title: 'Tekniskt fel',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: svs.syndicate.core.templates.technical_failure_request_activation(syndicate.toJSON())
          }],
          actions: [{
            title: 'Ok'
          }]
        }));
      }
      svs.ui.loader.show();
      svs.core.jupiter.post(options, successFn.bind(self), errorFn);
    },
    terminateSyndicate(syndicate) {
      const self = this;
      const currentSyndicate = this.getSyndicate(syndicate.get('syndicateId'));
      function terminateSyndicate(previusDialog) {
        const options = {
          path: "/social/".concat(api, "/syndicates/").concat(syndicate.get('syndicateId')),
          data: {
            terminate: true
          }
        };
        function successFn() {
          svs.ui.loader.hide();
          const syndicateId = syndicate.get('syndicateId');
          currentSyndicate.trigger('destroy', syndicate);
          self.logger.debug("Successfully terminated syndicate: ".concat(syndicate.get('syndicateName')));
          svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.TUR,
            icon: 'thumbs-up',
            title: 'Klart',
            message: [{
              type: svs.ui.dialog.message.TEXT,
              text: svs.syndicate.core.templates.terminate_syndicate_confirmation(syndicate.toJSON())
            }],
            actions: [{
              title: 'Ok',
              callback() {
                self.getChannel().trigger('TerminatedSyndicate', {
                  syndicateId
                });
              }
            }]
          }));
          previusDialog.close();
        }
        function errorFn(textStatus) {
          svs.ui.loader.hide();
          self.logger.error("Error when terminating syndicate: ".concat(textStatus));
          svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.TUR,
            type: svs.ui.dialog.type.ERROR,
            title: 'Tekniskt fel',
            message: [{
              type: svs.ui.dialog.message.TEXT,
              text: svs.syndicate.core.templates.technical_failure_terminate_syndicate(syndicate.toJSON())
            }],
            actions: [{
              title: 'Ok'
            }]
          }));
          previusDialog.close();
        }
        svs.ui.loader.show();
        svs.core.jupiter.put(options, successFn.bind(self), errorFn);
      }
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'spela-tillsammans',
        title: 'Bekräfta',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: svs.syndicate.core.templates.confirm_terminate_syndicate(syndicate.toJSON())
        }],
        actions: [{
          title: 'Avbryt'
        }, {
          title: 'Avsluta laget',
          showLoader: true,
          callback() {
            terminateSyndicate(dialog);
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    },
    rejectRecommendation(option) {
      if (!option.withoutConfirm) {
        const rejectDialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'help',
          title: 'Vill du avvisa insättningsförfrågan?',
          actions: [{
            title: 'Avbryt'
          }, {
            title: 'Avvisa',
            showLoader: true,
            callback: () => {
              this.makeRejection(option.syndicate, rejectDialog);
            }
          }]
        });
        svs.ui.dialog.api.add(rejectDialog);
      } else {
        this.makeRejection(option.syndicate);
      }
    },
    makeRejection(syndicate, previousDialog) {
      const options = {
        path: '/social/1/syndicates/rejectdepositrequest',
        data: {
          syndicateId: syndicate.get('syndicateId')
        }
      };
      if (!previousDialog) {
        svs.ui.loader.show();
      }
      svs.core.jupiter.post(options, () => {
        this.getChannel().trigger('RejectedDeposit', {
          syndicateId: syndicate.get('syndicateId')
        });
        if (previousDialog) {
          previousDialog.close();
        } else {
          svs.ui.loader.hide();
        }
        const doneDialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'thumbs-up',
          title: 'Du har avvisat insättningsförfrågan',
          actions: [{
            title: 'Ok',
            callback() {
              doneDialog.close();
            }
          }]
        });
        svs.ui.dialog.api.add(doneDialog);
        this.logger.debug('Successfully rejected deposit request');
      }, (xhr, textStatus) => {
        this.logger.error("Error rejecting deposit request: ".concat(textStatus));
        const errorDialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.ERROR,
          title: 'Tekniskt fel',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: 'Kunde inte avvisa insättning, försök igen.'
          }],
          actions: [{
            title: 'Ok'
          }]
        });
        svs.ui.dialog.api.add(errorDialog);
        if (previousDialog) {
          previousDialog.close();
        }
      });
    },
    getChannel() {
      return Radio.channel('syndicate');
    }
  });
  svs.syndicate.core.collections.syndicates = new svs.syndicate.core.collections.Syndicates();
})(Backbone, svs, Backbone.Radio);

 })(window);